import { render } from "./generarQrs.vue?vue&type=template&id=4163c5f6"
import script from "./generarQrs.vue?vue&type=script&lang=js"
export * from "./generarQrs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__